module.exports = __webpack_public_path__ + "img/pause2.774525d0.svg";